import { useMediaQuery } from '@mui/material';

/**
 * Determines the current device type based on media queries.
 *
 * Device type rules:
 * - Mobile: max-width 767px
 * - Tablet: min-width 768px, must have coarse pointer
 * - Desktop: anything else
 *
 * @returns DeviceType.mobile | DeviceType.tablet | DeviceType.desktop
 */
export const useDeviceType = () => {
	const isMobileWidth = useMediaQuery('(max-width: 767px)');
	// No max width for tablet, as they can get rather large sometimes. Not sure if we're going to cater to desktops with touch screens?
	const isTabletWidth = useMediaQuery('(min-width: 768px)');
	const hasCoarsePointer = useMediaQuery('(pointer: coarse)');

	if (isMobileWidth) return DeviceType.mobile;
	if (isTabletWidth && hasCoarsePointer) return DeviceType.tablet;
	return DeviceType.desktop;
};

export enum DeviceType {
	mobile = 'mobile',
	tablet = 'tablet',
	desktop = 'desktop'
}
